import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { AnonymousLockAccess } from "~/components/lock/AnonymousLockAccess";

export const Route = createFileRoute("/lock-access")({
	beforeLoad: () => {
		document.title = "bacehub | Open compartment";
	},
	component: RouteComponent,
	validateSearch: zodValidator(
		z.object({
			token: z.string().optional(),
		})
	),
});

function RouteComponent() {
	const { token } = Route.useSearch();
	return <AnonymousLockAccess token={token} />;
}
